<template>
    <div class="right-box">
        <div class="item">
            <div class="item-header">
                <el-select v-model="form.way" style="width: 206px">
                    <el-option label="农畜产品质量安全检验检测数据" value="way"></el-option>
                    <el-option label="检验检测受检单统计" value="way2"></el-option>
                    <el-option label="例行检测—抽检统计" value="way1"></el-option>
                </el-select>
            </div>
            <div class="item-content" v-if="form.way == 'way' && listData && listData.totalCount">
                <div class="item-content-child">
                    <img src="@/assets/imgs/base_right/right-1.png" class="left_img" />
                    <div class="info-box">
                        <div class="bg"></div>
                        <div class="info-detail">
                            <div>已完成任务 <span>{{ listData.totalCount.lxjcFinish || 0 }}</span></div>
                            <div>累计受检单数量 <span>{{ listData.totalCount.lxjc || 0 }}</span></div>
                        </div>
                    </div>
                </div>
                <div class="item-content-child">
                    <img src="@/assets/imgs/base_right/right-2.png" class="left_img" />
                    <div class="info-box">
                        <div class="bg bg-1"></div>
                        <div class="info-detail">
                            <div>已完成任务  <span>{{ listData.totalCount.zxjcFinish || 0 }}</span></div>
                            <div>累计受检单数量 <span>{{ listData.totalCount.zxjc || 0 }}</span></div>
                        </div>
                    </div>
                </div>
                <div class="item-content-child">
                    <img src="@/assets/imgs/base_right/right-3.png" class="left_img" />
                    <div class="info-box">
                        <div class="bg bg-2"></div>
                        <div class="info-detail">
                            <div>已完成任务  <span>{{ listData.totalCount.jdccFinish || 0 }}</span></div>
                            <div>累计受检单数量 <span>{{ listData.totalCount.jdcc || 0 }}</span></div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 饼状图 -->
            <div class="item-content" v-if="form.way == 'way1'" style="padding-top:0;">
                <div class="pie-box">
                    <div id="onePie"></div>
                    <div id="twoPie"></div>
                </div>
                <div class="bar-box" id="bar-box"></div>
            </div>
            <!-- 多列柱状图 -->
            <div class="item-content" v-if="form.way == 'way2'" style="padding-top:0">
                <div id="lineElementRight" class="wait-box" style="width:100%;height:100%;"></div>
            </div>
        </div>

        <div class="item">
            <!-- 乡镇速测室 -->
            <div class="item-header"></div>
            <div class="item-content">
                <div class="content-top">
                    <img src="../../assets/imgs/base_right/add_ress.png" />
                    <span>{{ currentInfo?.name || '呼和浩特' }}</span>
                </div>
                <div class="content-box" style="max-height: 350px;">
                    <div class="item-rank">
                        <div>乡镇速测室</div>
                        <div>合格证服务站</div>
                    </div>
                    <div class="item-rank" v-for="index in getMaxLength" :key="index">
                        <div>{{ deletion['jcs'][index]?.name || '' }}</div>
                        <div>{{ deletion['fwz'][index]?.name || '' }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import indexMins from "@/mixins/right.js"
import { request_get } from "@/utils/request.js"
export default {
    mixins: [indexMins],
    data() {
        return {
            form: {
                way: "way",
            },
            currentInfo: {},
            deletion: {},
            mainBodyCount: {},
            listData: {}
        };
    },
    props: {
        cityInfo: {
            type: Object,
            default: () => { }
        }
    },
    watch: {
        "form.way": function (val) {
            console.log(val, this.listData)
            if (val == "way1") {
                if (this.myChartLine) {
                    this.myChartLine.dispose()
                }
                this.$nextTick(function () {
                    //     if(this.myChartLine) {
                    //     this.myChartLine.dispose()
                    // }
                    this.initRightOnePie(document.getElementById("onePie"))
                    this.initRightOnePie(document.getElementById("twoPie"), 2)
                    this.rightBar(document.getElementById("bar-box"), this.listData)
                })
            } else if (val == "way2") {
                if (this.myChart) {
                    this.myChart.dispose()
                }
                if (this.barChart) {
                    this.barChart.dispose()
                }
                this.$nextTick(function () {
                    this.initLinesChart(document.getElementById("lineElementRight"), this.listData)
                })
            } else {
                // this.$forceUpdate()
                if (this.barChart) {
                    this.barChart.dispose();
                }
                if (this.myChart) {
                    this.myChart.dispose()
                }
                if (this.myChartLine) {
                    this.myChartLine.dispose()
                }
            }
        },
        cityInfo: {
            handler(val) {
                this.currentInfo = val
                this.$nextTick(function () {
                    this.getDeletion()
                    this.getDeletionData()
                })
            },
            deep: true
        }
    },
    mounted() {
        if (this.form.way == 'way1') {
            this.initRightOnePie(document.getElementById("onePie"))
            this.initRightOnePie(document.getElementById("twoPie"), 2)
            this.rightBar(document.getElementById("bar-box"))
        }

        this.currentInfo = this.cityInfo
        // if(Reflect.ownKeys(this.cityInfo).length) {
        this.getDeletion()
        this.getDeletionData();
        // }
    },
    computed: {
        getMaxLength() {
            return Object.keys(this.deletion).length ? Math.max(this.deletion.fwz.length - 1, this.deletion.jcs.length - 1) : 0
        }
    },
    methods: {
        // 获取监测数据
        getDeletionData() {
            request_get("/lsd/index/detectionSamplingCount", { area: this.currentInfo?.name }, res => {
                if (res.code == 200) {
                    this.listData = res.data || {};
                }
            })
        },
        // 获取检测站
        getDeletion() {
            request_get("/lsd/index/serviceStation", { area: this.currentInfo?.name || '' }, res => {
                if (res.code == 200) {
                    this.deletion = res.data || {};
                    this.$emit("setData", this.deletion)
                }
            })
        },


    }
};
</script>
<style lang="scss" scoped>
.right-box {
    width: 100%;
    height: 100%;
    color: white;
    display: flex;
    flex-direction: column;
    background: linear-gradient(-270deg,
            rgba(37, 106, 191, 0.1) 0%,
            #031a37 100%);

    .item {
        flex: 1;
        display: flex;
        flex-direction: column;
        padding: 0 20px 40px 20px;
        max-height: 50%;
        box-sizing: border-box;

        .item-header {
            height: 54px;
            width: 100%;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            background: url("../../assets/imgs/left-top-1-copy.png") no-repeat;
            background-size: 100% 100%;

        }

        &:nth-of-type(2) {
            .item-header {
                background: url("../../assets/imgs/base_right/bg-2.png") no-repeat;
            }

            .item-content {
                padding-top: 10px !important;
            }
        }

        .item-content {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding-top: 40px;
            box-sizing: border-box;

            &-child {
                display: flex;
                align-items: center;

                .left_img {
                    width: 94px;
                    height: 94px;
                }

                .info-box {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    margin-left: 35px;

                    .bg {
                        width: 100%;
                        height: 35px;
                        background: url("../../assets/imgs/base_right/bg-1.png") no-repeat;
                        background-size: 100% 35px;
                    }

                    .bg-1 {
                        background: url("../../assets/imgs/base_right/bg-6.png") no-repeat !important;
                        background-size: 100% 35px;
                    }

                    .bg-2 {
                        background: url("../../assets/imgs/base_right/bg-7.png") no-repeat !important;
                        background-size: 100% 35px;
                    }

                    .info-detail {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        margin-top: 4px;

                        div {
                            color: rgba(223, 242, 255, 0.80);
                            font-size: 18px;

                            span {
                                color: rgba(0, 240, 255, 0.80);
                                font-size: 24px;
                                margin-left: 20px;
                                font-weight: bold;
                            }
                        }
                    }
                }
            }



            //基础右侧第二个
            .content-top {
                display: flex;
                align-items: center;

                img {
                    width: 16px;
                    height: 20px;
                    margin-right: 6px;
                }

                span {
                    color: rgba(215, 239, 249, 1);
                    font-size: 18px;
                }
            }

            .content-box {
                flex: 1;
                display: flex;
                flex-direction: column;
                margin-top: 10px;
                overflow-y: auto;

                .item-rank {
                    display: flex;
                    align-items: center;
                    height: 33px;
                    padding: 0 24px;
                    color: rgba(215, 239, 249, 1);
                    margin-bottom: 4px;
                    background: linear-gradient(90deg, rgba(0, 20, 28, .3) 0%, rgba(1, 32, 45, .3) 50%, rgba(0, 20, 28, .3) 100%);
                    box-sizing: border-box;

                    div {
                        &:nth-of-type(1) {
                            flex: 1;
                            max-width: 180px;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 1;
                            overflow: hidden;
                            margin-right: 10px;
                            box-sizing: border-box;
                        }

                        &:nth-of-type(2) {
                            flex: 2;
                        }
                    }
                }
            }

            //饼状图
            .pie-box {
                height: 120px;
                display: flex;
                align-items: center;

                div {
                    flex: 1;
                    height: 100%;
                }
            }

            .bar-box {
                margin-top: 20px;
                flex: 1;
                width: 100%;
            }
        }
    }
}

::-webkit-scrollbar {
    width: 4px;
    height: 150px !important;
    background: linear-gradient(180deg, #96E3FF 0%, #339BFA 42%, #2182F9 63%, #3F94F1 81%, #76DEFF 100%) !important;
}
</style>
